// extracted by mini-css-extract-plugin
module.exports = {"wrap":"VanityTable_wrap__13mSo","container":"VanityTable_container__1FMvv","mirror":"VanityTable_mirror__2swHo","draws":"VanityTable_draws__Vi6gx"};